export const DUMMY_BOOKINGS = [
  {
    locker_bank_id: "LKR-A101",
    locker_bank_name: "Locker A-101",
    reserve_start: "2026-08-20T20:00:00",
    reserve_end: "2026-08-20T22:00:00",
    status: "BOOKED",
  },
  {
    locker_bank_id: "LKR-B204",
    locker_bank_name: "Pod B-204",
    reserve_start: "2026-08-20T09:00:00",
    reserve_end: "2026-08-20T12:30:00",
    status: "DONE",
  },
  {
    locker_bank_id: "LKR-C310",
    locker_bank_name: "Locker C-310",
    reserve_start: "2026-08-20T14:00:00",
    reserve_end: "2026-08-20T18:00:00",
    status: "BOOKED",
  },

  // ---- 22-07-2026 ----
  {
    locker_bank_id: "LKR-A101",
    locker_bank_name: "Locker A-101",
    reserve_start: "2026-07-22T11:00:00",
    reserve_end: "2026-07-24T13:00:00",
    status: "BOOKED",
  },

  // ---- 24-07-2026 (10:00 AM - 3:00 PM example) ----
  {
    locker_bank_id: "LKR-B204",
    locker_bank_name: "Pod B-204",
    reserve_start: "2026-07-24T10:00:00",
    reserve_end: "2026-07-24T15:00:00",
    status: "BOOKED",
  },
  {
    locker_bank_id: "LKR-D412",
    locker_bank_name: "Pod D-412",
    reserve_start: "2026-07-24T16:00:00",
    reserve_end: "2026-07-24T19:00:00",
    status: "BOOKED",
  },

  // ---- 25-07-2026 ----
  {
    locker_bank_id: "LKR-C310",
    locker_bank_name: "Locker C-310",
    reserve_start: "2026-07-25T08:00:00",
    reserve_end: "2026-07-25T10:00:00",
    status: "BOOKED",
  }
];
 